export const isUntouchedTemplateValue = (templateValue, value) => {
  if (templateValue === undefined || templateValue === null || templateValue === '') {
    return false;
  }

  return String(templateValue) === String(value);
};
